// src/screens/ViewMotoDetails.jsx

import React, { useState, useCallback } from "react";
// import { useAuth } from "../components/AuthContext";
import { storage } from "../firebaseConfig";
import { ref } from "firebase/storage";
import {
  Autocomplete,
  Box,
  TextField,
  Button,
  List,
  ListItem,
  Grid,
  Paper,
  Typography,
  useTheme,
  Backdrop,
  Modal,
  Fade,
  IconButton,
  ListItemText,
} from "@mui/material";
import { tokens } from "../theme";
import { useTranslation } from "react-i18next";
// Images
import emptyPhoto from "../assets/no_image.png";
// Icons
import CloseIcon from "@mui/icons-material/Close";
import FileIcon from "@mui/icons-material/InsertDriveFile";
import { useData } from "../components/DataProvider";

const ViewMotoDetails = ({ onClose, motoDetails }) => {
  //   const { currentUser } = useAuth();
  const [open, setOpen] = useState(true);
  const { docCategories } = useData();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();
  const [selectedDocCategory, setSelectedDocCategory] = useState(
    motoDetails.referenceDocuments
      ? []
      : t("You have not upload any reference document for this model")
  );
  const [documents, setDocuments] = useState([]);

  // Toggle modal open/close
  const handleClose = (e) => {
    setOpen(false);
    onClose();
  };

  const handleDocCategoryChange = (event, value) => {
    if (motoDetails.referenceDocuments) {
      setSelectedDocCategory(value);
      setDocuments(motoDetails.referenceDocuments[value] || []);
    } else {
      setSelectedDocCategory([
        t("You have not upload any reference document for this model"),
      ]);
    }
  };

  const handleFileOpenClick = (url) => {
    window.open(url, getFileName(url), "noopener,noreferrer");
  };

  const getFileName = useCallback((url2process) => {
    const httpsReference = ref(storage, url2process);
    return httpsReference.name;
  }, []);

  const handleCancel = async () => {
    handleClose();
  };

  const imageSize = {
    width: 400, // Adjust the width as needed
    height: 400, // Adjust the height as needed
  };

  const renderPhoto = () => {
    if (motoDetails.photo) {
      return (
        <img
          src={motoDetails.photo}
          alt="Motorcycle"
          style={{
            width: imageSize.width,
            height: imageSize.height,
            objectFit: "scale-down", // Maintain aspect ratio and cover container
            paddingBottom: "10px",
          }}
        />
      );
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return (
        <img
          src={emptyPhoto}
          alt="Empty"
          style={{
            width: imageSize.width,
            height: imageSize.height,
            objectFit: "scale-down", // Maintain aspect ratio and cover container
            paddingBottom: "10px",
          }}
        />
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={Backdrop}
      style={{ backdropFilter: "blur(10px)" }}
    >
      <Fade in={open} timeout={250}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                maxWidth: 600,
                width: "100%",
                margin: "0 auto",
                overflowY: "auto",
              }}
            >
              <Paper
                elevation={6}
                sx={{
                  padding: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  backdropFilter: "blur(10px)",
                  borderRadius: "20px",
                  maxHeight: "95vh",
                  width: "100%",
                  overflowY: "auto",
                }}
              >
                <IconButton
                  aria-label="delete"
                  onClick={handleCancel}
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                  }}
                >
                  <CloseIcon />
                </IconButton>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} container justifyContent="center">
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Typography
                        component="h1"
                        variant="r16"
                        paddingLeft="10px"
                      >
                        {t("View Details")}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} container justifyContent="center">
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      {renderPhoto()}
                    </Box>
                  </Grid>
                  {/* Brand Field */}
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={[]}
                      readOnly
                      fullWidth
                      disablePortal
                      id="combobox-brand"
                      name="brand"
                      color="secondary"
                      defaultValue={motoDetails.brand}
                      value={motoDetails.brand}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Brand")}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {},
                              "&:hover fieldset": {
                                borderColor: "white",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: colors.greenAccent[500],
                              },
                            },
                            "& .MuiInputLabel-root": {
                              //   color: "purple",
                              "&.Mui-focused": {
                                color: colors.greenAccent[500],
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              //   color: "purple",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  {/* Model Field */}
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={[]}
                      readOnly
                      fullWidth
                      disablePortal
                      id="combobox-model"
                      name="model"
                      color="secondary"
                      defaultValue={motoDetails.model}
                      value={motoDetails.model}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Model")}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {},
                              "&:hover fieldset": {
                                borderColor: "white",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: colors.greenAccent[500],
                              },
                            },
                            "& .MuiInputLabel-root": {
                              //   color: "purple",
                              "&.Mui-focused": {
                                color: colors.greenAccent[500],
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              //   color: "purple",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  {/* Year Field */}
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={[]}
                      readOnly
                      fullWidth
                      disablePortal
                      id="combobox-year"
                      name="year"
                      color="secondary"
                      getOptionLabel={(option) => option.toString()}
                      defaultValue={motoDetails.year}
                      value={motoDetails.year}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Year")}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {},
                              "&:hover fieldset": {
                                borderColor: "white",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: colors.greenAccent[500],
                              },
                            },
                            "& .MuiInputLabel-root": {
                              //   color: "purple",
                              "&.Mui-focused": {
                                color: colors.greenAccent[500],
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              //   color: "purple",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  {/* Current KM Field */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={t("Current KM")}
                      name="odometer"
                      color="secondary"
                      value={motoDetails.odometer}
                      readOnly
                      fullWidth
                      required
                    />
                  </Grid>
                  {/* Chasis Number Field */}
                  <Grid item xs={12} sm={12}>
                    <TextField
                      label={t("Chasis Number")}
                      name="chasis_no"
                      color="secondary"
                      value={motoDetails.chasis_no}
                      readOnly
                      fullWidth
                    />
                  </Grid>
                  {/* Motor Number Field */}
                  <Grid item xs={12} sm={12}>
                    <TextField
                      label={t("Motor Number")}
                      name="motor_no"
                      color="secondary"
                      value={motoDetails.motor_no}
                      readOnly
                      fullWidth
                      inputProps={{
                        inputMode: "decimal", // mobile keyboard with numbers and dot
                      }}
                    />
                  </Grid>
                  {/* License Plate Field */}
                  <Grid item xs={12} sm={12}>
                    <TextField
                      label={t("License Plate")}
                      name="license_plate"
                      color="secondary"
                      value={motoDetails.license_plate}
                      readOnly
                      fullWidth
                    />
                  </Grid>
                  {/* Description Field */}
                  <Grid item xs={12} sm={12}>
                    <TextField
                      label={t("Description")}
                      name="description"
                      color="secondary"
                      multiline
                      value={motoDetails.description}
                      readOnly
                      fullWidth
                    />
                  </Grid>
                  {/* Category Field */}
                  <Grid item xs={12}>
                    <Autocomplete
                      options={docCategories}
                      fullWidth
                      disablePortal
                      id="combobox-doccategory"
                      name="docCategory"
                      color="secondary"
                      value={selectedDocCategory || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value.value
                      }
                      onChange={(event, newValue) =>
                        handleDocCategoryChange(
                          "docCategory",
                          newValue ? newValue : ""
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Document Category")}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {},
                              "&:hover fieldset": {
                                borderColor: "white",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: colors.greenAccent[500],
                              },
                            },
                            "& .MuiInputLabel-root": {
                              //   color: "purple",
                              "&.Mui-focused": {
                                color: colors.greenAccent[500],
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              //   color: "purple",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>

                  {/* File List */}
                  <Grid item xs={6}>
                    <List>
                      {motoDetails.documents.map((doc, index) => (
                        <ListItem
                          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                          key={index}
                          secondaryAction={
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={() => handleFileOpenClick(doc)}
                            >
                              <FileIcon />
                            </IconButton>
                          }
                        >
                          <ListItemText primary={getFileName(doc)} />
                        </ListItem>
                      ))}
                    </List>
                  </Grid>

                  {/* File List */}
                  <Grid item xs={6}>
                    <List>
                      {documents.map((doc, index) => (
                        <ListItem
                          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                          key={index}
                          secondaryAction={
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={() => handleFileOpenClick(doc)}
                            >
                              <FileIcon />
                            </IconButton>
                          }
                        >
                          <ListItemText primary={getFileName(doc)} />
                        </ListItem>
                      ))}
                    </List>
                  </Grid>

                  {/* Cancel Button */}
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      onClick={handleCancel}
                      fullWidth
                      sx={{
                        mt: 1,
                        mb: 0,
                        backgroundColor: "#A60A05", //D10A03
                        color: "#fff",
                        height: "50px",
                      }}
                    >
                      <Typography
                        component="h1"
                        variant="r16"
                        paddingLeft="10px"
                      >
                        {t("Close")}
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Fade>
    </Modal>
  );
};

export default ViewMotoDetails;
